"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateRequestId = exports.generateUUID = void 0;
const generateUUID = () => {
    const UUID_LENGTH = 13;
    const possibleChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    return generateRandomString(possibleChars, UUID_LENGTH);
};
exports.generateUUID = generateUUID;
const generateRandomString = (possibleChars, length) => {
    let randomString = '';
    for (let i = 0; i < length; i++) {
        randomString += possibleChars.charAt(Math.floor(Math.random() * possibleChars.length));
    }
    return randomString;
};
const generateRequestId = () => {
    const REQUEST_ID_LENGTH = 20;
    const possibleChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    return generateRandomString(possibleChars, REQUEST_ID_LENGTH);
};
exports.generateRequestId = generateRequestId;
